'use strict';
import classNames from 'classnames';
import * as T from 'prop-types';
import React from 'react';

export function PinButtonView(props) {
  return (
    <div
      className={classNames("PinButton", props.className)}
      onClick={props.onClick}
    >
      <span className="PinButton__content">
        <i
          className={classNames("PinButton__pin icon ion-pin", {
            'PinButton__pin_pinned': props.isPinning ? !props.isPinned : props.isPinned,
          })}
          title={getTitle(props)}
        />
      </span>
    </div>
  );
}

PinButtonView.propTypes = {
  className: T.string,
  onClick: T.func.isRequired,
  title: T.string,
  isPinned: T.bool,
  isPinning: T.bool,

  pinIconTitle: T.string,
  pinningIconTitle: T.string,
  unpinIconTitle: T.string,
  unpinningIconTitle: T.string,
};

PinButtonView.messages = [
  {code: 'icon.pin.title', prop: 'pinIconTitle'},
  {code: 'icon.pinning.title', prop: 'pinningIconTitle'},
  {code: 'icon.unpin.title', prop: 'unpinIconTitle'},
  {code: 'icon.unpinning.title', prop: 'unpinningIconTitle'},
];

PinButtonView.messageProps = [
  'pinIconTitle',
  'pinningIconTitle',
  'unpinIconTitle',
  'unpinningIconTitle',
];

function getTitle(props) {
  if (props.isPinned) {
    return props.isPinning ? props.unpinningIconTitle : props.unpinIconTitle;
  } else {
    return props.isPinning ? props.pinningIconTitle : props.pinIconTitle;
  }
}



// WEBPACK FOOTER //
// ./src/js/priorities/components/PinButton/PinButtonView.js